module.exports = __webpack_public_path__ + "static/rest-5aa85fcd798f2c65b5ee5c8cc1929737.jpg";